// Client for the ServiceNow IT-orders endpoint served by backend-node-v2. Base URL =
// EnvironmentConfig.nodeService. Auth = MSAL JWT only — no kid, no x-proxy/x-proxy-token.
import { EnvironmentConfig } from "@me8eon/config";

type TokenFn = () => Promise<string | undefined>;

const BASE = `${EnvironmentConfig.nodeService}/service/orders`;

export type ListOrdersResponse = {
    result: {
        queryResult: Record<string, unknown>[];
        message: string;
    };
};

export async function listOrders(isActive: boolean, token: TokenFn): Promise<ListOrdersResponse> {
    const res = await fetch(`${BASE}?isActive=${isActive}`, {
        headers: { Authorization: `Bearer ${await token()}` },
    });
    if (!res.ok) throw new Error(`orders/list failed: ${res.status}`);
    return res.json();
}
